<template lang="pug">
  tr
    td
      router-link(:to="{ name: 'action', params: { id: action['Azioni.idAzione'], fase: action['Azioni.fase'] }}" title="Vedi Azione") {{ action['Azioni.azione'] }}
    td
      router-link(:to="{ name: 'action', params: { id: action['Azioni.idAzione'], fase: action['Azioni.fase'] }}" title="Vedi Azione") {{ action['Azioni.tipologia'] }}
    td
      router-link(:to="{ name: 'action', params: { id: action['Azioni.idAzione'], fase: action['Azioni.fase'] }}" title="Vedi Azione") {{ action['Azioni.fase'] }}
    td.view
      router-link(:to="{ name: 'action', params: { id: action['Azioni.idAzione'], fase: action['Azioni.fase'] }}" title="Vedi Azione")
        span →
</template>

<script>
export default {
  name: 'InterventionListItem',
  props: {
    action: Object
  },
  data () {
    return {
      filters: ''
    }
  },
  mounted: function () {
    // console.log('intervention', this.action)
  },
  methods: {
    placeHolder (e) {
      // console.log('🔥 InterventionListItem ', e)
    }
  }
}
</script>

<style lang='scss' scoped>
.content table td {
  font-size: .9rem;
  font-weight: 600;
  padding: 1em;
  line-height: 1.5;
  vertical-align: middle;
  a {
    color: #333333;
  }
  &.view {
    a {
      display: block;
      color: $link;
      span {
        display: block;
        transition: .1s ease-out;
      }
    }
  }
}

.content table tr:hover {
  background-color: lighten($mainBlu, 70%);
  td a span {
    transform: translateX(0.5em);
    transition: .2s ease-in-out;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/InterventionListItem.vue